import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import axios from 'axios'
import checkTheme from '@/mixins/checkTheme.js'
import Maska from 'maska'
import Cookies from 'js-cookie'
import vueDebounce from 'vue-debounce'

// axios configurations
axios.defaults.withCredentials = true
if (process.env.NODE_ENV === 'development') { axios.defaults.baseURL = 'http://localhost:8000' } // sistemaweb.opiniao
else { axios.defaults.baseURL = 'https://api.painelvarejo.com.br' }

axios.interceptors.response.use(response => response, error => {
    if (error.response.status == 401 && error.response.config.url !== 'api/login') {
        Cookies.set('authenticated', false)
        router.push('/')

        return Promise.reject()
    }
    return Promise.reject(error)
})

// store.dispatch('notify/addNotification', {type: 'success', message: 'Teste tes teste'}, {root: true})
checkTheme()

const app = createApp(App)

app.use(store)
app.use(router)
app.use(Maska)
app.use(vueDebounce)
app.mount('#app')
